export enum Experiments {
  SHOW_SESSIONS_ON_ECOM = 'specs.premium.subscriptions-tpa.fixSessionsOnEcom',
  EXPOSE_NEW_FEATURE = 'specs.premium.subscriptions-tpa.exposeNewFeature',
  VERIFY_GRACE_PERIOD_BEFORE_PAY_NOW = 'specs.premium.subscriptions-tpa.VerifyGracePeriodBeforePayNow',
  USE_INITIATE_PAYMENT_METHOD_SETUP = 'specs.premium.subscriptions-tpa.UseInitiatePaymentMethodSetup',
  ADVANCED_PAUSE_RESUME = 'specs.premium.subscriptions-tpa.advancedPauseResume',
  SHOW_NEW_BENEFIT_PROGRAMS = 'specs.subscriptions-tpa.showNewBenefitPrograms',
}
